// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../work/modules/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".phone-item[data-v-63f55f0a]{position:relative}.phone-item[data-v-63f55f0a]:after{content:\";\";position:absolute;right:-5px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
